export default "__VITE_ASSET__C7VzX$u0__"